import { createHttpClient } from "./http";

/**
 * Dados da empresa do usuário logado (Configurações > Sua conta). Nenhuma rota
 * recebe id: o backend usa a empresa do token.
 */
export class MinhaEmpresaRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	headers() {
		return { Authorization: `Bearer ${localStorage.getItem("access_token")}` };
	}

	mensagemDeErro(error, padrao) {
		const mensagem = error.response?.data?.message;
		if (Array.isArray(mensagem)) return mensagem[0];
		return mensagem || padrao;
	}

	async get() {
		try {
			const result = await this.axios.get("minha-empresa-distribuidor", { headers: this.headers() });
			return result.data;
		} catch (error) {
			throw new Error(this.mensagemDeErro(error, "Erro ao carregar os dados da empresa."));
		}
	}

	async update(dados) {
		try {
			const result = await this.axios.patch("minha-empresa-distribuidor", dados, { headers: this.headers() });
			return result.data;
		} catch (error) {
			throw new Error(this.mensagemDeErro(error, "Erro ao salvar os dados da empresa."));
		}
	}

	async getLogo() {
		try {
			const result = await this.axios.get("minha-empresa-distribuidor/logo", { headers: this.headers() });
			return result.data;
		} catch (error) {
			throw new Error(this.mensagemDeErro(error, "Erro ao carregar o logo."));
		}
	}

	async updateLogo(arquivo) {
		const formData = new FormData();
		formData.append("logo", arquivo);
		try {
			const result = await this.axios.put("minha-empresa-distribuidor/logo", formData, { headers: this.headers() });
			return result.data;
		} catch (error) {
			throw new Error(this.mensagemDeErro(error, "Erro ao enviar o logo."));
		}
	}

	async deleteLogo() {
		try {
			const result = await this.axios.delete("minha-empresa-distribuidor/logo", { headers: this.headers() });
			return result.data;
		} catch (error) {
			throw new Error(this.mensagemDeErro(error, "Erro ao remover o logo."));
		}
	}
}
